/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface AccountDetailsUpdateRequest {
  accountId: number;
  notes?: string;
  jurisdiction?: string;
  accountSubType?: AccountDetailsUpdateRequest.AccountSubTypeEnum;
  /**
   * True - means \'Internal\' account.
   */
  internalAccount?: boolean;
}
export namespace AccountDetailsUpdateRequest {
  export const AccountSubTypeEnum = {
    Btm: 'BTM',
    Exchange: 'EXCHANGE',
    Web3: 'WEB_3',
    Fund: 'FUND',
  } as const;
  export type AccountSubTypeEnum = (typeof AccountSubTypeEnum)[keyof typeof AccountSubTypeEnum];
}
